import {Action} from "@ngrx/store";
import {HostingPhpConfig} from "../../websites/website/hosting/info/hosting-php-config";

export const LOAD_PHP_CONFIGS: string = '[info] Load Php Configs';
export const LOAD_PHP_CONFIGS_SUCCESS: string = '[info] Load Php Configs Success';
export const LOAD_PHP_CONFIGS_FAIL: string = '[info] Load Php Configs Fail';

export class LoadPhpConfigs implements Action {
  readonly type: string = LOAD_PHP_CONFIGS;
  constructor(public payload: number) {}
}

export class LoadPhpConfigsSuccess implements Action {

  readonly type: string = LOAD_PHP_CONFIGS_SUCCESS;

  constructor(public payload: { websiteId: number; entities: HostingPhpConfig }) {}

}

export class LoadPhpConfigsFail implements Action {

  readonly type: string = LOAD_PHP_CONFIGS_FAIL;
  constructor(public payload: string) {}

}


export type PhpConfigsAction = LoadPhpConfigs | LoadPhpConfigsSuccess | LoadPhpConfigsFail;
